// ══════════════════════════════════════════════
//  hora.logic — motor puro del selector de hora (TimeInput), 2026-09-10.
//  Máscara HH:MM en 24 h que sigue a quien teclea, lectura tolerante y
//  aritmética de minutos. Sin DOM. Valor canónico 'HH:MM' (lo que guarda
//  la base como `time` se lee igual: 'HH:MM:SS' se recorta).
// ══════════════════════════════════════════════
const pad2 = (n) => String(n).padStart(2, '0');

export const esHora = (v) => /^([01]\d|2[0-3]):[0-5]\d$/.test(String(v || ''));
export const armarHora = (h, m) =>
  (Number.isInteger(h) && Number.isInteger(m) && h >= 0 && h <= 23 && m >= 0 && m <= 59) ? `${pad2(h)}:${pad2(m)}` : null;

// 'HH:MM' o 'HH:MM:SS' → 'HH:MM'; lo que no es hora → ''
export const formatearHora = (v) => {
  const m = String(v || '').match(/^(\d{2}):(\d{2})/);
  return m && esHora(`${m[1]}:${m[2]}`) ? `${m[1]}:${m[2]}` : '';
};

// Máscara que entiende cómo se teclea una hora: "0930" y "930" son 09:30,
// "245" es 2:45 (24 no es hora), "9:30", "9.30", "9 30" y "9h30" valen igual.
// La hora toma dos dígitos solo si juntos son ≤ 23; los minutos, dos dígitos.
export const mascaraHora = (texto) => {
  const limpio = String(texto || '').toLowerCase().replace(/[.\sh]/g, ':').replace(/[^\d:]/g, '');
  let h = '', m = '', enMin = false;
  for (const ch of limpio) {
    if (ch === ':') { if (h && !enMin) enMin = true; continue; }
    if (!enMin) {
      if (h.length === 0) { h = ch; continue; }
      if (h.length === 1 && Number(h + ch) <= 23) { h += ch; continue; }
      enMin = true; m = ch; continue;
    }
    if (m.length < 2) m += ch;
  }
  return enMin ? `${h}:${m}` : h;
};

// ¿Ya trae minutos completos? Mientras se teclea solo se emite entonces.
export const horaCompleta = (texto) => /^\d{1,2}:\d{2}$/.test(String(texto || '').trim());

// Lee lo tecleado: "9" y "12" son en punto, "9:3" es 9:30 (los minutos se
// teclean de decenas a unidades). null si no es una hora real.
export const parsearHora = (texto) => {
  const t = mascaraHora(texto);
  if (!t) return null;
  const [hs, ms = ''] = t.split(':');
  if (!hs) return null;
  return armarHora(Number(hs), ms ? Number(ms.padEnd(2, '0')) : 0);
};

// Suma minutos dando la vuelta al día
export const sumarMinutos = (hora, n) => {
  const base = esHora(hora) ? hora : '00:00';
  const [h, m] = base.split(':').map(Number);
  const t = (((h * 60 + m + n) % 1440) + 1440) % 1440;
  return armarHora(Math.floor(t / 60), t % 60);
};

export const ahora = () => {
  const d = new Date();
  return armarHora(d.getHours(), d.getMinutes());
};

export const HORAS = Array.from({ length: 24 }, (_, i) => pad2(i));
export const MINUTOS = Array.from({ length: 12 }, (_, i) => pad2(i * 5));
